/** @internal */
export const TypeId = /*#__PURE__*/Symbol.for("@effect/platform/HttpClientError");
//# sourceMappingURL=httpClientError.js.map